import OrderRenter from './OrderRenter'

export default OrderRenter
